<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="发票类型"
      edit-title
      id-key="InvoiceTypeId"
      :data="data"
      :line-form="true"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-form-item label="发票类型" prop="InvoiceTypeName">
          <el-input v-model="data.InvoiceTypeName" placeholder="请输入发票类型"></el-input>
        </el-form-item>
        <el-form-item label="默认税率" prop="DefTaxRate">
          <el-input v-model="data.DefTaxRate" v-num placeholder="请输入默认税率">
            <span slot="append">%</span>
          </el-input>
        </el-form-item>
        <el-form-item label prop="NeedNo">
          <el-checkbox v-model="data.NeedNo">需要发票号码</el-checkbox>
        </el-form-item>
        <el-form-item label prop="IsDeduction">
          <el-checkbox v-model="data.IsDeduction">是否可以抵扣税额</el-checkbox>
        </el-form-item>
        <el-form-item label="序号" prop="Sn">
          <el-input-number :min="0" v-model="data.Sn"></el-input-number>
          <span class="t-tips" v-if="!isMB">*值越小排得越前</span>
        </el-form-item>
        <el-form-item label="状态" prop="Status">
          <el-radio-group v-model="data.Status" class="detail-span">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        InvoiceTypeId: 0,
        InvoiceTypeName: "",
        DefTaxRate: null, //默认税率
        NeedNo: true,
        IsDeduction:false,
        Sn: 0,
        Status: 1,
      },
      api: require("@/api/ba/invoiceType").default,
      isMB: this.$store.state.isMB,
      rules: {
        InvoiceTypeName: [{ required: true, message: "发票类型不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened(data) {
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });
    },
  },
};
</script>